import {CanvasSkeleton} from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/CanvasSkeleton"

export const MobileSkeletonMenu = () => {
  return (
      <div className="flex gap-2 p-4">
        <CanvasSkeleton className="h-8 w-1/6" />
        <CanvasSkeleton className="h-8 w-1/6" />
        <CanvasSkeleton className="h-8 w-1/6" />
        <CanvasSkeleton className="h-8 w-1/2" />
      </div>
  )
}
